var basex = require('base-x')
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

module.exports = basex(ALPHABET)



//////////////////
// WEBPACK FOOTER
// ./~/bs58/index.js
// module id = 483
// module chunks = 0